import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiResponse } from '@domain/api';
import { HaulierItem, SlaughterhouseItem } from '@hjc/masterdata-types';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PartnersService {
  private http = inject(HttpClient);

  async getSlaughterhousePartners() {
    return firstValueFrom(this.http.get<ApiResponse<SlaughterhouseItem[]>>('/api/slaughterhouses'));
  }

  async getSlaughterhouseById(id: string) {
    return firstValueFrom(this.http.get<ApiResponse<SlaughterhouseItem>>(`/api/slaughterhouses/${id}`));
  }

  async getLogisticsPartners() {
    return firstValueFrom(this.http.get<ApiResponse<HaulierItem[]>>('/api/hauliers'));
  }

  async getLogisticPartnerById(id: string) {
    return firstValueFrom(this.http.get<ApiResponse<HaulierItem>>(`/api/hauliers/${id}`));
  }

  async getHaulierById(id: string) {
    return firstValueFrom(this.http.get<ApiResponse<HaulierItem>>(`/api/hauliers/${id}`));
  }
}

export type PartnerItem = HaulierItem | SlaughterhouseItem;
